import { Component, Input, OnInit } from '@angular/core';
import { CardLinkingService, LinkedCard } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'fgbcl-card-linked-single',
  templateUrl: './card-linked-single.component.html',
  styleUrls: ['./card-linked-single.component.scss'],
})
export class CardLinkedSingleComponent implements OnInit {
  @Input() linkedCard: LinkedCard;
  deleteCard: boolean = false;
  externalCardId: string;
  constructor(private cardLinkingServices: CardLinkingService, private modalService: NgbModal) {}

  ngOnInit(): void {}

  /**
   * Delete the linked Card.
   * @param cardId select card id.
   */
  deleteLinkedCard() {
    this.cardLinkingServices.deleteCard(this.externalCardId).toPromise();
    this.cancel();
  }

  /**
   * Open confirmation model for Delete the linked Card.
   * @param content model id.
   */
  openModel(content: any) {
    this.deleteCard = !this.deleteCard;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }

  /**
   * close confirmation model for Delete the linked Card.
   */
  cancel() {
    this.modalService.dismissAll();
  }
}
